// src/components/hook-form/RHFCurrencyField.js
import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import { TextField, InputAdornment } from '@mui/material';

// ----------------------------------------------------------------------

RHFCurrencyField.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    helperText: PropTypes.node,
    prefix: PropTypes.string,
    maxValue: PropTypes.number,
    disabled: PropTypes.bool,
};

export default function RHFCurrencyField({
    name,
    label,
    helperText,
    prefix = 'Rp',
    maxValue = 999999999999,
    disabled = false,
    ...other
}) {
    const { control } = useFormContext();

    // ✅ Format number with thousand separators (1000000 → "1.000.000")
    const formatNumber = (value) => {
        if (value === null || value === undefined || value === '') return '';
        let numStr = value.toString();
        numStr = numStr.split('.')[0];
        numStr = numStr.replace(/\D/g, '');
        if (numStr === '0' || numStr === '') return '';
        return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    };

    // ✅ Parse formatted string to number ("1.000.000" → "1000000")
    const parseNumber = (value) => {
        if (!value && value !== 0) return '';
        return value.toString().replace(/\./g, '').split('.')[0];
    };

    const handleChange = (e, field) => {
        let value = e.target.value || '';

        // Remove non-numeric characters except dots
        value = value.replace(/[^\d.]/g, '');

        // Parse to numeric
        const numeric = parseNumber(value);

        // Check max value
        if (Number(numeric) > maxValue) {
            return;
        }

        // ✅ Update form dengan numeric string
        field.onChange(numeric);
    };

    const handleBlur = (field) => {
        // Remove leading zeros on blur
        if (field.value) {
            const cleaned = field.value.toString().replace(/^0+/, '') || '0';
            field.onChange(cleaned);
        }
    };

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <TextField
                    {...field}
                    fullWidth
                    label={label}
                    value={formatNumber(field.value)}
                    onChange={(e) => handleChange(e, field)}
                    onBlur={() => handleBlur(field)}
                    error={!!error}
                    helperText={error ? error?.message : helperText}
                    placeholder="0"
                    disabled={disabled}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">{prefix}</InputAdornment>
                        ),
                        inputMode: 'numeric',
                    }}
                    inputProps={{
                        pattern: '[0-9.]*',
                        style: { textAlign: 'right' },
                    }}
                    {...other}
                />
            )}
        />
    );
}